






import { defineComponent } from '@vue/composition-api';
import { BellIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'NotificationYellowAlertIcon',
    components: {
        BellIcon,
    },
    props: {
        dropdown: {
            type: Boolean,
            default: false,
        },
    },
});
